import routes from '@root/routes';
import { parse, stringify } from 'qs';
import { useLocation } from 'react-router-dom';
import useNavigate from '@shared/useNavigate';

type Tabs = 'location' | 'media' | 'listing';

export default function useTabs({ tourbookId }: { tourbookId: string }) {
  const { search } = useLocation();
  const queryParams = parse(search, { ignoreQueryPrefix: true });

  const currentPage: Tabs = (queryParams.page as Tabs | undefined) || 'location';

  const routeWithPage = (page: Tabs) =>
    `${routes.tourbookNewExternalListing(tourbookId)}${stringify(
      { page },
      { addQueryPrefix: true },
    )}`;
  const navigate = useNavigate();
  const goTo = (page: Tabs) => () => navigate(routeWithPage(page));

  return {
    currentPage,
    isOnLocation: currentPage === 'location',
    isOnMedia: currentPage === 'media',
    isOnListing: currentPage === 'listing',
    goToLocation: goTo('location'),
    goToMedia: goTo('media'),
    goToListing: goTo('listing'),
  };
}
